import { k as _objectSpread2 } from '../_rollupPluginBabelHelpers-6a814b33.js';

var QA_ATTRIBUTES = {
  TAG: 'data-qa-tag',
  STATES: 'data-qa-states'
};
/**
 * @param states - in format { loading: true, disabled: false } or 'loading,disabled' etc
 * @returns {{}}
 */

var makeQAStates = function makeQAStates() {
  var states = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var attributes = {};

  if (typeof states === 'string') {
    attributes[QA_ATTRIBUTES.STATES] = states;
  } else if (states) {
    var statesList = [];
    Object.keys(states).forEach(function (key) {
      if (states[key]) {
        statesList.push(key);
      }
    });

    if (statesList.length) {
      attributes[QA_ATTRIBUTES.STATES] = statesList.join(',');
    }
  }

  return attributes;
};
/**
 * @param tag
 * @param states - in format { loading: true, disabled: false } or 'loading,disabled' etc
 * @returns {{}}
 */

var makeQAAttributes = function makeQAAttributes(tag) {
  var states = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var attributes = _objectSpread2({}, makeQAStates(states));

  if (tag) {
    attributes[QA_ATTRIBUTES.TAG] = tag;
  }

  return attributes;
};

export { QA_ATTRIBUTES, makeQAAttributes, makeQAStates };
//# sourceMappingURL=qaAttributes.js.map
